// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__f_XmW","head":"ProcedureTableInfo_head__2qRIy"};